<template>
    <div>
        <div style="background: #ffffff; height: 100vh;">
            <div class="container">
                
                <div class="d-flex justify-content-between align-items-baseline">
                    <h3 class="bills-text">
                        <!-- <span class="fa fa-chevron-left"></span> -->
                        Bills
                    </h3>
                    <h5 class="history-text" @click="routeTo('bills-history')">History</h5>
                </div>
                <h6 class="essentials">Essentials</h6>
                <div class="essentials-holding">
                    
                    <div class="essentials-items" @click="routeTo('bills-payment/airtime')">
                        <div>
                            <div>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#F8F9FA"/>
                                    <path d="M13.6321 10.7602L13.2966 10.0052C13.0772 9.51157 12.9675 9.26473 12.8034 9.07584C12.5978 8.83912 12.3298 8.66495 12.03 8.57321C11.7907 8.5 11.5206 8.5 10.9804 8.5C10.1902 8.5 9.79504 8.5 9.46335 8.65191C9.07263 8.83085 8.71978 9.2194 8.57918 9.6255C8.45983 9.97024 8.49403 10.3245 8.56239 11.0331C9.29017 18.5751 13.4251 22.7101 20.9671 23.4379C21.6757 23.5062 22.03 23.5404 22.3747 23.421C22.7809 23.2805 23.1694 22.9276 23.3484 22.5369C23.5002 22.2052 23.5002 21.8101 23.5002 21.0198C23.5002 20.4796 23.5002 20.2096 23.427 19.9703C23.3353 19.6705 23.1611 19.4025 22.9244 19.1968C22.7355 19.0328 22.4887 18.9231 21.995 18.7036L21.24 18.3681C20.7055 18.1306 20.4381 18.0117 20.1665 17.9859C19.9065 17.9611 19.6445 17.9976 19.4011 18.0924C19.1469 18.1914 18.9222 18.3786 18.4727 18.7532C18.0254 19.126 17.8017 19.3124 17.5284 19.4122C17.286 19.5008 16.9657 19.5336 16.7105 19.496C16.4226 19.4536 16.2022 19.3357 15.7613 19.1001C14.3896 18.3671 13.6332 17.6106 12.9001 16.239C12.6645 15.7981 12.5467 15.5776 12.5043 15.2897C12.4667 15.0346 12.4995 14.7142 12.588 14.4719C12.6878 14.1986 12.8743 13.9749 13.2471 13.5275C13.6216 13.0781 13.8089 12.8534 13.9079 12.5991C14.0026 12.3558 14.0391 12.0937 14.0144 11.8337C13.9885 11.5621 13.8697 11.2948 13.6321 10.7602Z" stroke="#F45AAF" stroke-width="1.25" stroke-linecap="round"/>
                                </svg>
                            </div>
                            <p>Airtime</p>
                        </div>
                    </div>
                    <div class="essentials-items" @click="routeTo('bills-payment/data')">
                        <div>
                            <div>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#F8F9FA"/>
                                    <path d="M12.875 18.084C14.5417 16.4173 17.4583 16.4173 19.125 18.084" stroke="#06C8BC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21.4167 15.5833C18.277 12.8056 13.9167 12.8056 10.5834 15.5833" stroke="#06C8BC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7.66663 13.0833C12.9298 8.63891 19.0701 8.6389 24.3333 13.0832" stroke="#06C8BC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M16 22.25C16.6904 22.25 17.25 21.6904 17.25 21C17.25 20.3096 16.6904 19.75 16 19.75C15.3096 19.75 14.75 20.3096 14.75 21C14.75 21.6904 15.3096 22.25 16 22.25Z" stroke="#06C8BC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <p>DATA</p>
                        </div>
                    </div>
                    <div class="essentials-items" @click="routeTo('bills-payment/electricity')">
                        <div>
                            <div>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#F8F9FA"/>
                                    <path d="M11.0745 18.4987C10.7592 17.7899 10.5834 17.0013 10.5834 16.1703C10.5834 13.084 13.0085 10.582 16 10.582C18.9916 10.582 21.4167 13.084 21.4167 16.1703C21.4167 17.0013 21.2409 17.7899 20.9255 18.4987" stroke="#A447C2" stroke-width="1.25" stroke-linecap="round"/>
                                    <path d="M16 7.66602V8.49935" stroke="#A447C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M24.3333 16H23.5" stroke="#A447C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.49996 16H7.66663" stroke="#A447C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21.892 10.1074L21.3027 10.6967" stroke="#A447C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10.6973 10.6967L10.108 10.1074" stroke="#A447C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18.0975 22.0875C18.9395 21.8152 19.2772 21.0445 19.3722 20.2694C19.4005 20.0378 19.21 19.8457 18.9767 19.8457L13.0641 19.8459C12.8228 19.8459 12.6289 20.0507 12.6578 20.2903C12.7508 21.064 12.9856 21.6291 13.8779 22.0875M18.0975 22.0875C18.0975 22.0875 14.0248 22.0875 13.8779 22.0875M18.0975 22.0875C17.9963 23.7084 17.5282 24.3503 16.0057 24.3323C14.3772 24.3624 14.0026 23.569 13.8779 22.0875" stroke="#A447C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <p>Eletricity</p>
                        </div>
                    </div>
                    <div class="essentials-items" @click="routeTo('bills-payment/cable-tv')">
                        <div>
                            <div>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#F8F9FA"/>
                                    <path d="M17.6666 8.5H14.3333C11.1906 8.5 9.61925 8.5 8.64293 9.47631C7.66663 10.4526 7.66663 12.024 7.66663 15.1667C7.66663 18.3093 7.66663 19.8807 8.64293 20.857C9.61925 21.8333 11.1906 21.8333 14.3333 21.8333H17.6666C20.8093 21.8333 22.3807 21.8333 23.357 20.857C24.3333 19.8807 24.3333 18.3093 24.3333 15.1667C24.3333 12.024 24.3333 10.4526 23.357 9.47631C22.3807 8.5 20.8093 8.5 17.6666 8.5Z" stroke="#0033EA" stroke-width="1.25" stroke-linecap="round"/>
                                    <path d="M17.6666 8.5H14.3333C11.1906 8.5 9.61925 8.5 8.64293 9.47631C7.66663 10.4526 7.66663 12.024 7.66663 15.1667C7.66663 18.3093 7.66663 19.8807 8.64293 20.857C9.61925 21.8333 11.1906 21.8333 14.3333 21.8333H17.6666C20.8093 21.8333 22.3807 21.8333 23.357 20.857C24.3333 19.8807 24.3333 18.3093 24.3333 15.1667C24.3333 12.024 24.3333 10.4526 23.357 9.47631C22.3807 8.5 20.8093 8.5 17.6666 8.5Z" stroke="black" stroke-opacity="0.2" stroke-width="1.25" stroke-linecap="round"/>
                                    <path d="M20.0833 18.9167C20.0833 18.1802 20.6802 17.5833 21.4167 17.5833M17.4167 18.9167C17.4167 16.7075 19.2075 14.9167 21.4167 14.9167M14.75 18.9167C14.75 15.2347 17.7347 12.25 21.4167 12.25" stroke="#0033EA" stroke-width="1.25" stroke-linecap="round"/>
                                    <path d="M20.0833 18.9167C20.0833 18.1802 20.6802 17.5833 21.4167 17.5833M17.4167 18.9167C17.4167 16.7075 19.2075 14.9167 21.4167 14.9167M14.75 18.9167C14.75 15.2347 17.7347 12.25 21.4167 12.25" stroke="black" stroke-opacity="0.2" stroke-width="1.25" stroke-linecap="round"/>
                                    <path d="M21 21.834L21.8333 23.5007" stroke="#0033EA" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21 21.834L21.8333 23.5007" stroke="black" stroke-opacity="0.2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11 21.834L10.1666 23.5007" stroke="#0033EA" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11 21.834L10.1666 23.5007" stroke="black" stroke-opacity="0.2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <p>TV</p>
                        </div>
                    </div>
                </div>
                <h6 class="essentials mt-5 mb-5 text-left">Recent bills history</h6>

                <div v-if="loading">
                    <PageLoader></PageLoader>
                </div>
                <div v-else class="recent-payment-holder">
                    <div class="recent-payment-item" v-for="(item, index) in parsedData.slice(0, 5)" :key="index">
                        <div class="recent-payment-top" @click="togglePanel(index)">
                            <div class="d-flex align-items-baseline">
                                <!-- <div class="mr-3">
                                    <img src="../../assets/billpayment/AEDC-LOGO.svg" alt="bill"></img>
                                </div> -->
                            
                                <h5 v-if="item">{{item.name}} {{ item.category }}</h5>
                            </div>
                            <div class="d-flex align-items-baseline">
                                <h6>₦{{Number(item.amount).toLocaleString()}}</h6>
                                <span style="font-size: 20px;"><i class="fa fa-chevron-up" :class="[activeIndex ? 'fa-chevron-right' : 'fa-chevron-down']"></i></span>
                            </div>
                        </div>
                        <div class="date-status">
                            <p v-if="item.data">{{item.data.vendTime | moment}}</p>
                            <p v-else>{{item.updated_at | moment}}</p>
                            <span v-if="item.status == '1'" class="successful">Successful</span>
                            <span v-if="item.status == '0'" class="failed">Failed</span>
                        </div>

                        <div class="panel-slide" v-if="activeIndex == index && item.category == 'electricity'">
                            <p><span>Meter Number:</span>  0983****3623 </p>
                            <p v-if="item.data"><span>Token: </span> {{item.data.token}}</p>
                        </div>
                    </div>

                    <!-- <Pagination
                        v-if="transactionsHitory"
                        @pageData="dataFromChild($event)"
                    ></Pagination> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Pagination from "../../components/Pagination.vue";
import { Service } from "../../store/service";
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
const Api = new Service();
export default {
    name: "BillHome",
    components: {
        PageLoader,
        // Pagination
    },
    data() {
        return {
            loading: false,
            activeIndex: null,
            transactionsHitory: [],
            parsedData: [],
        }
    },
    mounted() {
        this.fetchBillHistory();
    },
    methods: {
        routeTo(route) {
            this.$router.push({
            path: route
            })
            .catch(() => {});
        },
        togglePanel(index) {
            if(this.activeIndex != index) {
                this.activeIndex = index;
            }
            else {
               this.activeIndex = null;
            }
        },
        async fetchBillHistory() {
            this.loading = true;
            try {
                await Api.getRequest(`billshistory?page=1&perpage=10`)
                .then(res => {
                    this.loading = false;
                    // console.log("Bills history", res)
                    
                    if (res.status == 200) {
                        // this.pageUrlGlobal();
                        this.transactionsHitory = res.data.transactions;
                        const parsedArray = res.data.transactions.map(item => ({...item,
                            data: JSON.parse(item.dump)
                        }));
                        this.parsedData = parsedArray;
                    }
                    else {
                        return this.$store.commit("setApiFailed", "Error occured");
                    }
                })
                .catch(err => {
                    console.log("ERROR", err);
                    this.loading = false;
                });
            } finally {
            // console.log("Closed connection");
            }
        },
        // dataFromChild(data) {
        //     // console.log("data from child", data);
        //     this.transactionsHitory = data.data.transactions;
        // },
        // pageUrlGlobal() {
        //     Api.pushPageURL(`billshistory`);
        // }
    },
    filters: {
        moment: function(date) {
        return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        },
        moment2: function(date) {
        return moment(date).format("MMMM Do YYYY");
        }
    }
}

</script>


<style lang="scss" scoped>
.bills-text {
    font-family: Lato;
    font-weight: 600;
    font-size: 20px;
    line-height: 60px;
    text-align: left;
    color: #1A1A1A;
    margin-top: 40px;
    span {
        font-size: 18px;
        margin-right: 20px;
    }
}

.history-text {
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 60px;
    color: #4688F4;
    cursor: pointer;
    margin-top: 40px;

}
.essentials {
    font-family: Lato;
    font-weight: 500;
    font-style: Medium;
    font-size: 18px;
    line-height: 20px;
    color: #1A1A1A;
}
.essentials-holding {
    display: flex;
    justify-content: center;
    overflow: scroll;
    margin-top: 40px;

}
.essentials-items {
    background: #F8F9FA;
    width: 150px;
    height: 150px;
    border-radius: 6px;
    padding: 20px;
    cursor: pointer;
}
.essentials-items:hover {
    background: #f2f3f4;
}
.essentials-items:not(:last-child) {
    margin-right: 30px;
}
.essentials-items > div:first-child {
    margin-top: 24px;
}

.recent-payment-item:not(:last-child) {
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid #E4E4E4;
}

.recent-payment-top {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    h5 {
        font-family: Lato;
        font-weight: 500;
        font-style: Medium;
        font-size: 18px;
        line-height: 64px;
        // text-align: center;
        color: #1A1A1A;
        text-transform: capitalize;
    }
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        line-height: 64%;
        color: #1A1A1A;
        margin-right: 10px;
    }
}

.date-status {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #555555;
        text-align: left;
    }
    span {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        // line-height: 64px;
        padding: 4px 8px;
        border-radius: 50px;
        // text-align: right;
    }
    
    .successful {
        color: #4688F4;
        background: #F8F9FA;
    }
    .failed {
        color: #DC3545;
        background: #DC35450D;
    }
}

.panel-slide {
    text-align: left;
    margin-top: 10px;
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 100%;
        color: #555555;
    }
    span {
        margin-right: 10px;
    }
}

@media only screen and (max-width: 599px) {
    .recent-payment-top {
        h5 {
            font-size: 14px;
        }
        h6 {
            font-size: 14px;
        }
        .panel-slide {
            font-size: 14px;
        }
    }
    .date-status { 
        p {
            margin-bottom: 0;
        }
        span {
            font-size: 14px;
            padding: 8px;
        }
    }
    .essentials-items {
        min-width: 120px;
        max-height: 120px;
    }
    .essentials-holding {
        justify-content: space-between;
    }
    .essentials-items:not(:last-child) {
        margin-right: 11px;
    }
    .essentials-items > div:first-child {
        margin-top: 12px;
    }
}
</style>